/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FormFieldType, LoginFormField, QuestionType } from '../typings';

export class LoginFormFieldBuilder {
  // @ts-ignore
  private _fieldId: LoginFormField['fieldId'] = 'FieldId not provided';
  // @ts-ignore
  private _type: FormFieldType = FormFieldType.Login;
  // @ts-ignore
  private _typeValue: FormFieldType = FormFieldType.Login;
  // @ts-ignore
  private _questionType: LoginFormField['questionType'] = QuestionType.Unknown;
  // @ts-ignore
  private _field?: LoginFormField['field'];

  constructor() {}

  public fieldId(value: string): this {
    this._fieldId = value;
    return this;
  }

  public questionType(value: QuestionType): this {
    this._questionType = value;
    return this;
  }

  public field(value: LoginFormField['field']): this {
    this._field = value;
    return this;
  }

  public build(): LoginFormField {
    return Object.keys(this)
      .filter(key => key.startsWith('_'))
      .reduce(
        (obj, key) => ({
          ...obj,
          [key.slice(1)]: this[key as keyof this],
        }),
        {} as LoginFormField,
      );
  }
}
